import { isServiceUnavailableResult } from "../../util/apiAvailability";

/**
 * Picks the notification for a failed users/pre_auth_check. An API outage
 * (5xx / network failure) is not an auth refusal, so it must not read as
 * "Login not authorized" — users take that for an IP restriction.
 *
 * Returns { kind: "blocked" | "unavailable" | "refused", type, message, description }
 * where `type` is the antd notification method to use.
 */
export const getPreAuthFailureNotice = (
  result,
  t,
  refusedDescription = "Login not authorized"
) => {
  if (result?.code === "BOT_BLOCKED" || result?.blocked) {
    return {
      kind: "blocked",
      type: "error",
      message: "Access denied",
      description:
        "Automated access to the login page is not allowed. Please use a standard browser.",
    };
  }
  if (isServiceUnavailableResult(result)) {
    return {
      kind: "unavailable",
      type: "warning",
      message: t("service_unavailable.title", "Service temporarily unavailable"),
      description: t(
        "service_unavailable.login",
        "The service is temporarily unavailable. Please try again shortly."
      ),
    };
  }
  return {
    kind: "refused",
    type: "error",
    message: "Error",
    description: refusedDescription,
  };
};
